<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Add User</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-text-field label="Full Name (First and Last)" placeholder="Enter full name" required v-model="fullName" />
        <base-email-field class="tw-mt-2" label="Email Address" placeholder="Enter email address" required v-model="emailAddress" />
        <div class="tw-font-thin">Roles</div>
        <div class="tw-grid tw-grid-cols-1 tw-gap-3 tw-py-2 tw-px-3">
          <base-checkbox label="Administrator" value="predictile_administrator" v-model="roles" />
          <base-checkbox label="Management" value="predictile_management" v-model="roles" />
          <base-checkbox label="Operations" value="predictile_operations" v-model="roles" />
        </div>
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4 sm:tw-mt-0">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="add-user-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";

export default {
  components: {
    InlineError,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      fullName: null,
      emailAddress: null,
      roles: [],
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    reset() {
      this.$refs.form.reset();
      this.roles = [];
    },
    show() {
      this.$refs.modal.show();
      this.reset();
    },
    hide() {
      this.$refs.modal.hide();
      this.reset();
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      try {
        this.isLoading = true;
        await this.$axios.post("/admin/users", {
          fullName: this.fullName,
          emailAddress: this.emailAddress,
          roles: this.roles,
        });
        this.$emit("save");
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "User Created", message: `${this.fullName} was created successfully` });
        this.hide();
      } catch (err) {
        this.errorTitle = `Error creating ${this.fullName}`;
        this.errorMessage = "Sorry, we had trouble creating this user. The technicians have been notified. Please try again.";
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
